
const zh_HK_shell = {
    "appAccess.serviceUnavailableTitle": "服務目前不可用",
    "appAccess.serviceUnavailableDescription": "此服務目前不可用，因為此商戶尚未啟用一個或多個依賴服務。",
    "appAccess.serviceUnavailableDependencies": "如需開通，請聯絡銷售啟用：{services}。",
    "appAccess.accessDeniedTitle": "沒有存取權限",
    "appAccess.accessDeniedDescription": "你目前的角色沒有權限存取此頁面。",
    "appAccess.accessDeniedDetail": "如需存取此服務，請聯絡你的管理員。",
    "appAccess.appUnavailableEyebrow": "應用不可用",
    "appAccess.appNotFoundTitle": "找不到應用",
    "appAccess.appNotFoundDescription": "目前 shell 目錄中不存在所選應用。",
    "appAccess.goToApp": "進入應用",
    "appAccess.backToDashboard": "返回儀表板",
    "appAccess.accessDeniedEyebrow": "沒有存取權限",
    "appAccess.unavailableAppEyebrow": "應用不可用",
    "appAccess.noDescription": "目前項目暫無應用說明。",
    "appAccess.permissionDeniedNote": "此服務已為商戶啟用，但你目前的角色無權存取。",
    "appAccess.dependencyMissingNote": "此服務依賴以下服務：{services}。如需啟用所需服務，請聯絡銷售。",
    "appAccess.unavailableNote": "此應用可供探索，但目前商戶工作區尚未開放。",
    "appAccess.viewDocs": "查看文件",
    "appAccess.contactSales": "聯絡銷售",
    "form.back": "返回",
    "ApiConsumer.userName": "使用者名稱",
    "ApiConsumer.user_name": "使用者名稱",
    "ApiConsumer.api_key": "API 金鑰",
    "ApiConsumer.api_secret": "API 密鑰",
    "ApiConsumer.mcp_id": "MCP ID",
    "merchantAccount.merchantCompany": "商戶公司",
    "merchantAccount.merchantCode": "商戶代碼",
    "merchantAccount.timeZone": "時區",
    "merchantAccount.action": "操作",
    "merchantAccount.switch": "查看",
    "merchantAccount.merchantLoginError": "商戶登入失敗",
    "form.userName": "使用者名稱",
    "form.userNamePlaceholder": "使用者名稱",
    "form.apiKey": "API 金鑰",
    "form.apiKeyPlaceholder": "API 金鑰",
    "form.apiSecret": "API 密鑰",
    "form.apiSecretPlaceholder": "API 密鑰",
    "form.mcpId": "MCP ID",
    "form.mcpIdPlaceholder": "MCP ID",
    "ApiConsumer.addBtn": "新增 API 使用者",
    "ApiConsumer.filterBtn": "篩選",
    "ApiConsumer.activeFilters": "已套用的篩選條件：",
    "merchantApiConsumer.userName": "使用者名稱",
    "merchantApiConsumer.entityId": "實體 ID",
    "merchantApiConsumer.merchantCode": "商戶代碼",
    "merchantApiConsumer.mcpId": "MCP ID",
    "merchantApiConsumer.merchantId": "商戶 ID",
    "merchantApiConsumer.apiKey": "API 金鑰",
    "merchantApiConsumer.apiSecret": "API 密鑰",
    "merchantApiConsumer.isActive": "是否啟用",
    "merchantApiConsumer.Enabled": "已啟用",
    "merchantApiConsumer.disabled": "已停用",
    "merchantApiConsumer.apiTree": "API 樹",
    "merchantApiConsumer.created_at": "建立時間",
    "merchantApiConsumer.updated_at": "最後修改時間",
    "merchantApiConsumer.apitree": "API 樹",
    "ApiConsumer.action": "操作",
    "ApiConsumer.totalsSummary": "顯示第 {from} 至 {to} 項，共 {total} 項結果",
    "form.merchantCode": "商戶代碼",
    "form.merchantCodePlaceholder": "商戶代碼",
    "form.isActive": "是否啟用",
    "form.statusPlaceholder": "狀態",
    "ApiConsumer.permissionTitle": "{role_name} 的權限",
    "global.noPermission": "抱歉，你沒有權限存取此內容。",
    "ApiConsumer.addTitle": "建立 API 使用者",
    "ApiConsumer.editTitle": "編輯 API 使用者",
    "ApiConsumer.deleteApiConsumer": "刪除 API 使用者",
    "ApiConsumer.confirmModalDelMsg": "確定要刪除此 API 使用者嗎？",
    "form.contactPhonePlaceholder": "聯絡電話",
    "merchantSettings.fieldName": "欄位名稱",
    "merchantSettings.fieldCode": "欄位代碼",
    "merchantSettings.fieldType": "欄位類型",
    "merchantSettings.fieldValue": "欄位值",
    "settings.apiConsumer": "API 使用者",
    "form.role": "角色",
    "form.rolePlaceholder": "角色",
    "merchantUsers.inviteId": "ID",
    "merchantUser.role": "角色",
    "merchantUsers.Resend": "重新傳送",
    "global.InvitationSuccess": "邀請成功！",
    "roleAdmin.all": "全部",
    "form.role_name": "角色名稱",
    "form.role_namePlaceholder": "角色名稱",
    "form.slug": "Slug",
    "roleAdmin.remark": "備註",
    "roleAdmin.Enabled": "已啟用",
    "roleAdmin.noSpace": "Slug 只能由字母、數字及 -_ 組成",
    "form.slugPlaceholder": "Slug",
    "form.description": "描述",
    "form.descriptionPlaceholder": "描述",
    "form.remark": "備註",
    "form.remarkPlaceholder": "備註",
    "form.status": "狀態",
    "userAdmin.syncSuccess": "同步成功！",
    "userAdmin.syncFail": "同步失敗！",
    "merchantUsers.all": "全部",
    "merchantUsers.refresh": "重新整理",
    "merchantUsers.updated_at": "最後修改時間",
    "settings.UserAdmin": "使用者",
    "settings.RoleAdmin": "角色",
    "settings.invitation": "待接受邀請",
    "admin.userAdmin": "使用者管理",
    "LeadSource.dateRange": "日期",
    "dashboard.day": "今天",
    "dashboard.week": "本週",
    "dashboard.month": "本月",
    "dashboard.year": "今年",
    "dashboard.last_x": "最近 x 天",
    "dashboard.custom": "自訂",
    "form.days": "天數",
    "rules.days": "請輸入有效數字",
    "dashboard.apply": "套用",
    "global.lastDaysNotCorrect": "最近天數不正確",
    "global.dateRangeNotCorrect": "日期範圍不正確",
    "global.startTimeLaterEndTime": "開始時間不能晚於結束時間",
    "merchantSubscribes.totalsSummary": "顯示第 {from} 至 {to} 項，共 {total} 項結果",
    "form.isEmail": "請輸入有效的電郵地址",
    "Order.action": "操作",
    "global.ticketDeleteDone": "刪除成功。",
    "global.confirmDelModalTitle": "確認刪除",
    "global.confirmModalDelMsg": "確定要刪除此項目嗎？",
    "form.operator": "運算子",
    "form.operatorPlaceholder": "運算子",
    "form.start_date": "開始日期",
    "form.end_date": "結束日期",
    "inviteAccept.inviteAcceptTitle": "接受邀請",
    "inviteAccept.rememberMeLabel": "記住我",
    "inviteAccept.forgetBtn": "忘記密碼？",
    "inviteAccept.signup": "註冊",
    "inviteAccept.accept": "接受",
    "global.copyright ": "Copyright @ 2024 BCNetcom. 版權所有。",
    "form.verificationCode": "驗證碼",
    "form.verificationCodePlaceholder": "驗證碼",
    "form.serviceCode": "服務代碼",
    "form.placeholder": "請輸入{name}",
    "form.serviceCodePlaceholder": "服務代碼",
    "form.serviceName": "服務名稱",
    "form.serviceNamePlaceholder": "服務名稱",
    "form.reset": "重設",
    "form.ok": "儲存",
    "form.merchantId": "商戶 ID",
    "form.isRequired": "此欄位為必填",
    "form.cancel": "取消",
    "form.firstname": "名字",
    "form.firstnamePlaceholder": "名字",
    "form.lastname": "姓氏",
    "form.lastnamePlaceholder": "姓氏",
    "form.email": "電郵",
    "form.emailPlaceholder": "電郵",
    "form.contactEmailPlaceholder": "聯絡電郵",
    "form.phoneArea": "電話區號",
    "form.contactPhone": "聯絡電話",
    "navigation.availableApps": "可用APP",
    "navigation.exploreMoreApps": "探索更多APP",
    "navigation.settings": "設定",
    "navigation.openAppLauncher": "開啟APP啟動器",
    "navigation.appLauncher": "APP啟動器",
    "navigation.appLauncherDescription": "在儀表板、已啟用的APP及不可用的APP之間切換。",
    "navigation.additionalSubscription": "需要額外訂閱才可使用",
    "global.systemLandingTitle": "歡迎回來！",
    "global.systemLandingMessage": "我們將為你提供先進的 AI 業務分析及強大的 CRM 系統！",
    "DashboardHeader.labelTips": "歡迎使用儀表板，查看你的業務概覽及最新數據。",
    "dashboard.orderPerformanceSummary": "訂單表現摘要",
    "dashboard.from": "從",
    "dashboard.to": "至",
    "dashboard.revenue": "收入",
    "dashboard.vsLastPeriod": "與上一期間比較",
    "dashboard.totalOrders": "訂單總數",
    "dashboard.averageOrder": "平均訂單",
    "dashboard.shipping": "配送",
    "dashboard.quantity": "數量",
    "dashboard.newCustomers": "有订单的新客户",
    "dashboard.contacts": "聯絡人",
    "dashboard.totalContacts": "聯絡人總數",
    "dashboard.momGrowth": "按月增長",
    "dashboard.members": "會員",
    "dashboard.totalMembers": "會員總數",
    "dashboard.membersWithOrder": "有訂單的會員",
    "dashboard.subscribers": "訂閱者",
    "dashboard.totalSubscribers": "訂閱者總數",
    "dashboard.unsubscriptionCurrentMonth": "本月取消訂閱",
    "dashboard.activeAutomatedJourney": "啟用中的自動化旅程",
    "dashboard.activeCampaigns": "啟用中的活動",
    "dashboard.engagement": "互動率",
    "dashboard.total": "總計",
    "dashboard.status": "狀態",
    "dashboard.detail": "詳情",
    "dashboard.customer": "客戶",
    "dashboard.updatedTo": "更新至 2023-12-12",
    "dashboard.successfulDeal": "成功交易",
    "dashboard.dealsCount": "23 宗交易",
    "dashboard.pendingDeal": "待處理交易",
    "dashboard.pendingDealsCount": "1045 宗交易",
    "dashboard.rejectedDeal": "已拒絕交易",
    "dashboard.rejectedDealsCount": "1675 宗交易",
    "dashboard.upcomingDeal": "即將進行的交易",
    "dashboard.upcomingDealsCount": "234 宗交易",
    "homeMenu.merchantAccount": "商戶帳戶",
    "homeMenu.myProfile": "我的個人資料",
    "homeMenu.security": "安全性",
    "global.webName": "<spanStyle>e-Com365</spanStyle> 已更名为 <linkStyle>Gaxas.ai</linkStyle> —— 我們的新品牌，專注於統一客戶互動及AI智慧體。",
    "global.copyrightText": "Copyright @ 2025 BCNetcom. 版權所有。",
    "global.copyrightText2026": "Copyright @ {year} e-Com365.com. 版權所有。",
    "homeUser.profile": "個人資料",
    "homeUser.loginout": "登出",
    "form.password": "密碼",
    "form.newPassword": "新密碼",
    "form.newPasswordPlaceholder": "新密碼",
    "form.confirmPassword": "確認密碼",
    "form.confirmPasswordPlaceholder": "確認密碼",
    "form.currentPassword": "目前密碼",
    "form.currentPasswordPlaceholder": "目前密碼",
    "form.passwordPlaceholder": "密碼",
    "form.firstName": "名字",
    "form.lastName": "姓氏",
    "form.userEmail": "使用者電郵"
};

export {
    zh_HK_shell
}
